import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form/immutable';
import IconButton from 'material-ui/IconButton';
import FlatButton from 'material-ui/FlatButton';
import FontIcon from 'material-ui/FontIcon';
import Subheader from 'material-ui/Subheader';
import DatePicker from 'material-ui/DatePicker';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import _ from 'lodash';
import moment from 'moment';

import { fetchEmployees } from '../../actions/employees';
import { showDialog, hideDialog } from '../../actions/dialogs';
import { addResource, removeResource, addResources, setResourceEmployee } from '../../actions/jobs';
import ResourceInput from '../ResourceInput';

import ReduxDialog from '../Common/ReduxDialog';

import { getDialogContextProp } from '../../reducers/helper';
import { sortStrings, toArray, id } from '../../utils/helper';
import { saveJobResourcesRoutine } from '../../routines';

import styles from './styles';

const filterResources = (resources, date) => (_.keys(resources) || [])
  .map((resourceId) => _.assign({ id: resourceId }, resources[resourceId]))
  .filter((resource) => {
    return resource.from && moment(resource.from).startOf('day').isSame(date);
  });

class AssignResources extends Component {
  static propTypes = {
    job: PropTypes.object,
    employees: PropTypes.array.isRequired,
    roles: PropTypes.array.isRequired,

    fetchEmployees: PropTypes.func.isRequired,

    currentDate: PropTypes.object,

    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,

    addResources: PropTypes.func.isRequired,
    addResource: PropTypes.func.isRequired,
    removeResource: PropTypes.func.isRequired,
    setResourceEmployee: PropTypes.func.isRequired,

    handleSubmit: PropTypes.func.isRequired,

    saveJobResources: PropTypes.func.isRequired,
  };

  state = {
    resources: [],
    dates: [],
    dateIdx: 0,
  };

  componentWillMount() {
    this.props.fetchEmployees();
  }

  // componentWillReceiveProps(newProps) {
  //   console.log('componentWillReceiveProps', newProps);
  //   if (newProps.job && newProps.job.resources) {
  //     const dates = _.uniq(_.values(newProps.job.resources).reduce((res, val) => {
  //       res.push(moment(val.from).startOf('day'));
  //       return res;
  //     }, []));
  //
  //     const resources = filterResources(newProps.job.resources, moment(newProps.currentDate).startOf('d'))
  //       .sort((a, b) => {
  //         return sortStrings(a.id, b.id);
  //       });
  //
  //     this.setState({
  //       dates,
  //       resources,
  //     });
  //   }
  // }

  handleUpdateInput = (searchText, a, b, c) => {
    this.setState({
      searchText,
    });
  };

  // handleSelectEmployee = (employee) => {
  //   console.log('handleSelectEmployee', employee);
  //   this.pr
  // };

  handleSelectRole = (role) => {
    this.setState({
      role,
    });
  };

  // handleAddEmployee = () => {
  //   const { employee, role, resources = [] } = this.state;
  //
  //   if (resources.find((resource) => resource.employee.id === employee.id)) {
  //     return alert('Employee has already been added');
  //   }
  //
  //   resources.push({
  //     employee,
  //     role,
  //   });
  //
  //   this.setState({
  //     resources,
  //     employeeSearchText: '',
  //     roleSearchText: '',
  //   });
  // };

  handleAddResource = (spec) => {
    console.log('handleAddResource', spec);
    const resources = _.range(spec.quantity).map(() => _.assign(_.omit(spec, ['quantity']), { id: id() }));
    console.log('addRes', resources);
    this.props.addResources(this.props.job, resources);
  };

  handleRemoveResource = (resource) => {
    console.log('handleRemoveResource', resource);
    this.props.removeResource(this.props.job, resource);
  };

  handleResetResource = (state) => {
    console.log('handleResetResource', state);
    return state;
  };

  handleAssignResourcesToTasks = () => {
    this.props.hideDialog('assignResources');
    this.props.hideDialog('confirm');
    this.props.showDialog('assignResourcesToTasks');
  };

  handleSave = () => {
    const { job } = this.props;
    this.props.saveJobResources(job);

    // TODO restore
    // if (job.tasks && job.tasks.count > 0) {
    //   this.props.showDialog('assignResources');
    //   this.props.showDialog('confirm', {
    //     title: 'Assign resources to tasks',
    //     message: 'Would you like to assign resources to tasks?',
    //     buttons: [<FlatButton
    //       label="No"
    //       onClick={() => {
    //         this.props.hideDialog('confirm');
    //         this.props.hideDialog('assignResources');
    //       }}
    //     />,
    //       <FlatButton
    //         label="Yes"
    //         primary
    //         keyboardFocused
    //         onClick={this.handleAssignResourcesToTasks}
    //       />],
    //   });
    // } else {
      this.props.hideDialog('assignResources');
    // }
  };

  // handleAssignEmployeesToStages() {
  //   const { job } = this.props;
  //   this.props.showDialog('assignEmployeesToStages', {
  //     stages: job.stages,
  //   });
  // }

  renderNoData() {
    return (<TableRow key="nodata">
      <TableRowColumn colSpan={3} style={styles.noDataRow}>
        <FontIcon className="material-icons" style={styles.noData}>person</FontIcon>
        <div>No resources added yet...</div>
      </TableRowColumn>
    </TableRow>);
  }

  renderResource(resource) {
    const { employees } = this.props;
    let employee = null;
    if (resource.employee) {
      employee = employees.find(((employee) => employee.id === resource.employee.id));
    }
    // const employeeName = resource.employee ? `${resource.employee.name}` : '';
    return (<TableRow key={resource.id}>
      <TableRowColumn style={styles.timeCol}>{moment(resource.from).format('LT')}</TableRowColumn>
      <TableRowColumn style={styles.timeCol}>{moment(resource.to).format('LT')}</TableRowColumn>
      <TableRowColumn style={styles.roleCol}>{resource.role.name}</TableRowColumn>
      <TableRowColumn>
        <SelectField
          name="employee.id"
          style={styles.input}
          hintText="Employee"
          fullWidth
          value={employee ? employee.id : null}
          onChange={(evt, idx, employeeId) => this.props.setResourceEmployee(this.props.job, resource, employees.find((e) => e.id === employeeId))}
        >
          { (this.props.employees || []).map((e) => <MenuItem key={e.id} value={e.id} primaryText={e.name}/>)}
        </SelectField>
      </TableRowColumn>
      <TableRowColumn style={styles.actionCol}>
        <IconButton
          tooltip="Clear"
          tooltipPosition="bottom-center"
          onClick={() => this.props.setResourceEmployee(this.props.job, resource, null)}
        >
          <i className="material-icons">clear</i>
        </IconButton>
        <IconButton
          tooltip="Remove"
          tooltipPosition="bottom-center"
          onClick={() => this.handleRemoveResource(resource)}
        >
          <i className="material-icons">delete</i>
        </IconButton>
      </TableRowColumn>
    </TableRow>);
  }

  renderResources(resources, currentDate) {
    return (<div style={styles.resources}>
      <ResourceInput
        fixedDate={currentDate}
        onAdd={this.handleAddResource}
        onReset={this.handleResetResource}
      />

      <DatePicker
        ref={(dp) => this.dp = dp}
        autoOk
        style={styles.datePicker}
        onChange={(_, date) => this.setState({ currentDate: moment(date) })}
      />
      <div>
        <Table selectable={false}>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              <TableHeaderColumn style={styles.timeCol}>Start</TableHeaderColumn>
              <TableHeaderColumn style={styles.timeCol}>End</TableHeaderColumn>
              <TableHeaderColumn style={styles.roleCol}>Role</TableHeaderColumn>
              <TableHeaderColumn>Employee</TableHeaderColumn>
              <TableHeaderColumn style={styles.actionCol}></TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            { resources.length > 0 ? resources.map((resource) => this.renderResource(resource)) : this.renderNoData() }
          </TableBody>
        </Table>
      </div>
    </div>);
  }

  render() {
    const { handleSubmit, job, currentDate } = this.props;
    if (!job) {
      return (<div />);
    }

    if (!job) {
      return (<div />);
    }

    // const dates = _.uniq(_.values(newProps.job.resources).reduce((res, val) => {
    //   res.push(moment(val.from).startOf('day'));
    //   return res;
    // }, []));

    const resources = filterResources(job.resources, moment(currentDate).startOf('d'))
      .sort((a, b) => {
        return sortStrings(a.id, b.id);
      });

    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={() => this.props.hideDialog('assignResources')}
      />,
      <FlatButton
        label={'Save'}
        primary
        keyboardFocused
        onClick={()=>this.handleSave()}
      />,
    ];

    return (
      <ReduxDialog
        name="assignResources"
        title="Assign Resources"
        actions={actions}
        modal={false}
        autoScrollBodyContent
        bodyStyle={styles.body}
      >
        <form onSubmit={handleSubmit}>
          <div>
            <div style={styles.row}>
              <div style={styles.reference}>
                <label style={styles.label}>Reference</label>
                <div>{job.reference}</div>
              </div>
              <div style={styles.customer}>
                <label style={styles.label}>Customer</label>
                <div>{job.customer ? job.customer.name : ''}</div>
              </div>
              <div style={styles.description}>
                <label style={styles.label}>Description</label>
                <div>{job.description}</div>
              </div>
            </div>
            <div style={styles.row}>
              <div style={styles.date}>
                <label style={styles.label}>Start Date</label>
                <div>{moment(job.start).format('ll')}</div>
              </div>
              <div style={styles.date}>
                <label style={styles.label}>End Date</label>
                <div>{moment(job.end).format('ll')}</div>
              </div>
              <div style={styles.date}>
                <label style={styles.label}>Assignment Date</label>
                <div>{moment(currentDate).format('ll')}</div>
              </div>

            </div>

          </div>


          <Subheader>Role Assignments</Subheader>

          { this.renderResources(resources, currentDate) }
        </form>
      </ReduxDialog>
    );
  }
}

const form = reduxForm({
  form: 'AssignResources',  // a unique identifier for this form
})(AssignResources);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchEmployees,
    showDialog,
    hideDialog,
    addResources,
    addResource,
    setResourceEmployee,
    removeResource,
    saveJobResources: saveJobResourcesRoutine.trigger,
  }, dispatch);
}

function mapStateToProps(state) {
  const currentDate = getDialogContextProp(state.get('dialogs').get('dialogs'), 'assignResources', 'currentDate');

  return {
    job: state.get('jobs').get('job').toJS(),
    employees: state.get('employees').get('employees').toJS().sort((a, b) => sortStrings(a ? a.name : '', b ? b.name : '')),
    roles: toArray(state.get('roles').get('roles').toJS()),
    currentDate,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/AssignResources/index.js